import React from 'react';

const Work = () => {
    return (
        <div>
            <h1>Work</h1>
        </div>
    );
};

export default Work;